<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :aria-labelledby="imgName"
        role="presentation"
        preserveAspectRatio="none"
        :style="setStyle"
    >
        <title v-if="!!imgName" :id="imgName" lang="fr">{{ $l10n.__(`${imgName}-img-svg`) }}</title>

        <slot />
    </svg>
</template>

<script>
export default {
    props: {
        imgName: {
            type: String,
            required: false,
            default: null,
        },
        width: {
            type: [Number, String],
            required: false,
            default: 'auto',
        },
        height: {
            type: [Number, String],
            required: false,
            default: 'auto',
        },
    },

    computed: {
        setWidth() {
            return typeof this.width === 'string' ? this.width : `${this.width}px`;
        },
        setHeight() {
            return typeof this.height === 'string' ? this.height : `${this.height}px`;
        },
        setStyle() {
            return `width: ${this.setWidth}; height: ${this.setHeight};`;
        },
    },
};
</script>
